import { render } from "./CourseView.vue?vue&type=template&id=2a64bdde&scoped=true"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"

import "./CourseView.vue?vue&type=style&index=0&id=2a64bdde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a64bdde"]])

export default __exports__